
define('text!example/styleguide/res/templates/mct-example.html',[],function () { return '<div class="col">\n    <h3>Markup</h3>\n    <span class="w-markup">\n        <pre></pre>\n    </span>\n    <h3>Example</h3>\n    <div class="w-mct-example"></div>\n</div>\n';});

